var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownIcon, ArrowUpIcon, MinusIcon } from '@heroicons/react/20/solid';
import Badge from '@web/components/ui/Badge/Badge';
import { DiffTooltip, useDiffTooltip } from '@web/components/ui/Diff/DiffTooltip';
var BadgeDiff = function (_a) {
    var _b, _c;
    var diffValue = _a.diffValue, customStyles = _a.customStyles, arrowColor = _a.arrowColor;
    var _d = useDiffTooltip(diffValue, {
        arrowColor: arrowColor
    }), tooltipText = _d.tooltipText, tooltipId = _d.tooltipId;
    if (!diffValue) {
        return customStyles ? _jsx("div", { className: customStyles }) : null;
    }
    var renderContent = function (icon, label) {
        var content = (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "inline-flex h-5 w-5 shrink-0 items-center justify-center" }, { children: icon })), _jsx("span", __assign({ className: "inline-flex h-5 min-w-0 items-center font-normal leading-none text-gray-500 align-middle" }, { children: label }))] }));
        return (_jsx(DiffTooltip, __assign({ text: tooltipText, id: "badgeDiff-".concat(tooltipId) }, { children: content })));
    };
    if (diffValue.diff === 0) {
        var zeroIcon = (_jsx(MinusIcon, { width: 20, height: 20, className: "text-gray-400" }));
        var zeroLabel = (_b = diffValue.diffString) !== null && _b !== void 0 ? _b : '0%';
        return (_jsx(Badge, __assign({ color: "gray", className: "text-sm inline-flex items-center gap-0.5 text-gray-400", customStyles: customStyles }, { children: renderContent(zeroIcon, zeroLabel) })));
    }
    var isNegative = diffValue.diff < 0;
    var color = isNegative ? 'red' : 'green';
    var arrowIcon = isNegative ? (_jsx(ArrowDownIcon, { width: 20, height: 20, className: "text-red-500" })) : (_jsx(ArrowUpIcon, { width: 20, height: 20, className: arrowColor ? "text-".concat(arrowColor, "-500") : 'text-green-500' }));
    return (_jsx(Badge, __assign({ color: color, className: "text-sm inline-flex items-center gap-0.5 text-gray-500", customStyles: customStyles }, { children: renderContent(arrowIcon, (_c = diffValue.diffString) !== null && _c !== void 0 ? _c : '') })));
};
export default BadgeDiff;
